import { createBatchAnimation } from './createBatchAnimation';

export const animateSlideRight = () => {
  if (!document.querySelector('.animate-slide-right')) {
    return;
  }

  createBatchAnimation({
    selector: '.animate-slide-right',
    initialState: {
      autoAlpha: 0,
      x: -window.innerWidth,
    },
    resetState: {
      autoAlpha: 0,
      y: 25,
    },
    checkVisited: true,
  });
};
